import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../ui/loader/inner-loader";
import DataNotFound from "../ui/loader/data-not-found";
import { useApiCall } from "../custom-hooks/api-call";
import DynamicFilter from "../table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../icons/filter-funnel-01";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableFooter, TableHead, TableHeaderWrap, TableRow, } from "../table/table-layout";
import CustomizeTabsPopup from "../table/customize-table";
import Tooltip from "../ui/tooltip";
import { KPI, TitleHeading } from "../ui/layout";
import { Skeleton } from "@mui/material";
import { Users } from "lucide-react";
import { useParams, useSearchParams } from "react-router";
import { Brand, DateRange, Platform, TotalRoi } from "../icons/filter-icon";

const PPCProductSummary = () => {
  const {id} = useParams()
  const [searchParams] = useSearchParams();
  const preDate = searchParams.get("daterange");
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState({});
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState((preDate) ? [
    JSON.parse(preDate)
  ] : []);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [apiFilters, setApiFilters] = useState({});
  const [websiteId, setWebsiteId] = useState("");
  const [platformId, setPlatformId] = useState("");
  const [deviceId, setDeviceId] = useState("");

  useEffect(() => {
    // getData(isAlreadyDateUse ? {filter: [preDate]} : {});
    getData({});
  }, []);

  const getData = async ({ filter = filterReturn, page = "", fromList = false }) => {
    if (!page) {
      setIsLoading(true);
    }
    if(!fromList){
      if(!filter?.find(eachFilter => eachFilter?.name == "platform_id")?.value?.length){
        setPlatformId("");
      }
      if(!filter?.find(eachFilter => eachFilter?.name == "brand_id")?.value?.length){
        setWebsiteId("");
      }
      if(!filter?.find(eachFilter => eachFilter?.name == "device")?.value?.length){
        setDeviceId("");
      }
    }
    let extraUrl = `&page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-ppc-product-summary?product_id=${id}${extraUrl}`,
      });
      setList(res);
      setApiFilters(res.filters)
      // setTableHeaders(res.headers);
      // setSaveFilter(res?.custom_filters);
      // setFooter(res?.footer)
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "brand_id",
      label: "Brand",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: apiFilters?.brands,
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: Brand
    },
    {
      name: "platform_id",
      label: "Platform",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: apiFilters?.platforms,
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: Platform
    },
    {
      name: "device",
      label: "Device",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: apiFilters?.devices?.map((eachDevice) => ({id: eachDevice, name: eachDevice})),
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: TotalRoi
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateRange
    }
  ];

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={(!filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length) ?
            [
              {
                "name": "date_range",
                "label": "Date Range",
                "selectedOpt": "is",
                "value": lists?.date_filter,
                "isCrossDisable": true
              },
              ...filterReturn
            ]
            : filterReturn
          }
          onChange={(filters) => {
            console.log("filtersfiltersfilters", filters)
            setFilterReturn(filters);
            getData({ filter: filters });
          }}
        />
        <div className={Style.report_table__header}>
          <TitleHeading title={'PPC Product Summary'} />

          <div className={Style.bpfl_action}>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            {/* <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div> */}
          </div>
        </div>

        <TableCard className={"!p-[15px] !pr-[7px] h-full overflow-hidden"}>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {!isLoading ? (
              <>
                <KPI
                  icon={Users}
                  label={"Product"}
                  value={lists?.product}
                  extraClass={"theme"}
                  // sublabel={`Previous Month: ${eachKpi?.last}`}
                  // stateLable={`${lists?.summary?.avg_cpc?.replace("-", "")}`}
                  // positive={!lists?.summary?.avg_cpc.includes("-")}
                />
                <KPI
                  icon={Users}
                  label={"Avg CPC"}
                  value={lists?.summary?.avg_cpc}
                  // sublabel={`Previous Month: ${eachKpi?.last}`}
                  // stateLable={`${lists?.summary?.avg_cpc?.replace("-", "")}`}
                  // positive={!lists?.summary?.avg_cpc.includes("-")}
                />
                {/* <KPI
                  icon={Users}
                  label={eachKpi?.title}
                  value={eachKpi?.this}
                  sublabel={`Previous Month: ${eachKpi?.last}`}
                  stateLable={`${eachKpi?.mom_change?.replace("-", "")}`}
                  positive={!eachKpi?.mom_change.includes("-")}
                /> */}

                <KPI
                  icon={Users}
                  label={"CTR"}
                  value={lists?.summary?.ctr}
                  // sublabel={`Previous Month: ${eachKpi?.last}`}
                  // stateLable={`${lists?.summary?.ctr?.replace("-", "")}`}
                  // positive={!lists?.summary?.ctr.includes("-")}
                />

                <KPI
                  icon={Users}
                  label={"ROAS"}
                  value={lists?.summary?.roas}
                  extraClass={"green"}
                  // sublabel={`Previous Month: ${eachKpi?.last}`}
                  // stateLable={`${lists?.summary?.roas?.replace("-", "")}`}
                  // positive={!lists?.summary?.roas.includes("-")}
                />

                <KPI
                  icon={Users}
                  label={"Cost Per Lead"}
                  value={lists?.summary?.cost_per_lead}
                  // sublabel={`Previous Month: ${eachKpi?.last}`}
                  // stateLable={`${lists?.summary?.avg_cpc?.replace("-", "")}`}
                  // positive={!lists?.summary?.avg_cpc.includes("-")}
                />

                <KPI
                  icon={Users}
                  label={"Total Clicks"}
                  value={lists?.summary?.total_clicks}
                />

                <KPI
                  icon={Users}
                  label={"Total Impressions"}
                  value={lists?.summary?.total_impressions}
                />

                <KPI
                  icon={Users}
                  label={"Total Leads"}
                  value={lists?.summary?.total_leads}
                />

                <KPI
                  icon={Users}
                  label={"Total Revenue"}
                  value={lists?.summary?.total_revenue}
                />

                <KPI
                  icon={Users}
                  label={"Total Spend"}
                  value={lists?.summary?.total_spend}
                />
              </>
            ) : (
              Array.from({ length: 10 }).map((_, index) => (
                <div key={index} className="bg-white shadow rounded-xl p-4 animate-pulse">
                  {/* Top row: label + icon */}
                  <div className="flex items-center justify-between mb-2">
                    <Skeleton variant="text" width={80} height={16} />
                    <Skeleton variant="circular" width={20} height={20} />
                  </div>
                  {/* Value row */}
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <Skeleton variant="text" width={60} height={32} />
                    <Skeleton variant="rounded" width={40} height={20} />
                  </div>
                  {/* Sublabel */}
                  <Skeleton variant="text" width={80} height={12} />
                </div>
              ))
            )}
          </div>
          <div className="pt-10 flex flex-col gap-4">
            <div className="">
              <div className="pb-4">
                <TitleHeading title={'Breakdown By Website'} />
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : !lists?.breakdown_by_website?.length ? (
                <div className="w-full h-full flex items-center justify-center">
                  <DataNotFound title={"Data"} />
                </div>
              ) : (
                <>
                  <TableCard>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell header sticky><TableHeaderWrap>Website</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Spend</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Revenue</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>ROAS</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Leads</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CPL</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Clicks</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Impressions</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CTR</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CPC</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>% Product</TableHeaderWrap></TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.breakdown_by_website?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`} className={websiteId == eachList?.website_id ? "[&>td]:!bg-blue-300" : ""}>
                              <TableCell sticky>
                                <div className="flex items-center gap-[10px]">
                                  <div className="leading-5 underline decoration-dashed font-bold decoration-gray-500 cursor-pointer hover:opacity-70" onClick={() => {
                                    if(websiteId == eachList?.website_id){
                                      setWebsiteId("");
                                      let newFiltered = [...filterReturn?.filter((preFil) => preFil.name != "brand_id")]
                                      setFilterReturn(newFiltered);
                                      getData({filter: newFiltered, fromList: true})
                                    }else{
                                      setWebsiteId(eachList?.website_id);
                                      if(filterReturn?.find(eachFilter => eachFilter?.name == "brand_id")?.value?.length){
                                        let newFiltered = [...filterReturn?.filter((preFil) => preFil.name != "brand_id"), {
                                          name: "brand_id",
                                          label: "Brand",
                                          options: ["is"],
                                          selectedOpt: "is",
                                          value: [eachList?.website_id],
                                          type: "dropdown",
                                          dropdown: apiFilters?.brands,
                                          dropdownKey: "name",
                                          dropdownVal: "id",
                                          isMulti: true,
                                          isChecked: true
                                        }]
                                        setFilterReturn(newFiltered);
                                        getData({filter: newFiltered, fromList: true})
                                      }else{
                                        let newFiltered = [...filterReturn, {
                                          name: "brand_id",
                                          label: "Brand",
                                          options: ["is"],
                                          selectedOpt: "is",
                                          value: [eachList?.website_id],
                                          type: "dropdown",
                                          dropdown: apiFilters?.brands,
                                          dropdownKey: "name",
                                          dropdownVal: "id",
                                          isMulti: true,
                                          isChecked: true
                                        }]
                                        setFilterReturn(newFiltered);
                                        getData({filter: newFiltered, fromList: true})
                                      }
                                    }
                                  }}>{eachList?.website}</div>
                                </div>
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["spend"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["revenue"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["roas"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["leads"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["cpl"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["clicks"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["impr"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["ctr"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["cpc"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["%_of_product"] ?? "-"
                                }
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>

                      {/* <TableFooter>
                        <TableRow>
                          <TableCell header sticky className="!font-bold !bg-[#f6f7f7]"></TableCell>
                          {tableHeaders?.map((head, hIdx) => {
                            return (
                              head.is_visible === 1 && head.show == 1 ? (
                                <TableCell header key={`footer_cell_${hIdx}`} className="!font-bold !bg-[#f6f7f7]">
                                  {head.key === "status" ? (
                                    <StatusChip color={footer[head.key] === "Active" ? "green" : "red"}>
                                      {footer[head.key] || "--"}
                                    </StatusChip>
                                  ) : head.key === "assigned_user_department" ? (
                                    <TableDepartmentTag title={footer[head.key]} />
                                  ) : (head.key == "profit_loss" || head.key == "fresh_roi" || head.key == "total_roi") ? (
                                    <span
                                      className={
                                        footer[head.key]?.includes("-") ? "text-red-500" : (footer[head.key] == "$0.00" || footer[head.key] == "0.00%") ? "" : "text-green-500"
                                      }
                                    >
                                      {footer[head.key]}
                                    </span>
                                  ) : (
                                    footer[head.key] ?? "-"
                                  )}
                                </TableCell>
                              ) : null
                            )
                          }

                          )}
                        </TableRow>
                      </TableFooter> */}
                    </Table>
                  </TableCard>
                </>
              )}
            </div>

            <div className="">
              <div className="pb-4">
                <TitleHeading title={'Breakdown By Platform'} />
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : !lists?.breakdown_by_platform?.length ? (
                <div className="w-full h-full flex items-center justify-center">
                  <DataNotFound title={"Data"} />
                </div>
              ) : (
                <>
                  <TableCard>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell header sticky><TableHeaderWrap>Platform</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Spend</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Revenue</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>ROAS</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Leads</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CPL</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Clicks</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Impressions</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CTR</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CPC</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>% Product</TableHeaderWrap></TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.breakdown_by_platform?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`} className={platformId == eachList?.platform_id ? "[&>td]:!bg-blue-300" : ""}>
                              <TableCell sticky>
                                <div className="flex items-center gap-[10px]">
                                  <div className="leading-5 underline decoration-dashed font-bold decoration-gray-500 cursor-pointer hover:opacity-70" onClick={() => {
                                    if(platformId == eachList?.platform_id){
                                      setPlatformId("");
                                      let newFiltered = [...filterReturn?.filter((preFil) => preFil.name != "platform_id")]
                                      setFilterReturn(newFiltered);
                                      getData({filter: newFiltered, fromList: true})
                                    }else{
                                      setPlatformId(eachList?.platform_id);
                                      if(filterReturn?.find(eachFilter => eachFilter?.name == "platform_id")?.value?.length){
                                        let newFiltered = [...filterReturn?.filter((preFil) => preFil.name != "platform_id"), {
                                          name: "platform_id",
                                          label: "Platform",
                                          options: ["is"],
                                          selectedOpt: "is",
                                          value: [eachList?.platform_id],
                                          type: "dropdown",
                                          dropdown: apiFilters?.platforms,
                                          dropdownKey: "name",
                                          dropdownVal: "id",
                                          isMulti: true,
                                          isChecked: true
                                        }]
                                        setFilterReturn(newFiltered);
                                        getData({filter: newFiltered, fromList: true})
                                      }else{
                                        let newFiltered = [...filterReturn, {
                                          name: "platform_id",
                                          label: "Platform",
                                          options: ["is"],
                                          selectedOpt: "is",
                                          value: [eachList?.platform_id],
                                          type: "dropdown",
                                          dropdown: apiFilters?.platforms,
                                          dropdownKey: "name",
                                          dropdownVal: "id",
                                          isMulti: true,
                                          isChecked: true
                                        }]
                                        setFilterReturn(newFiltered);
                                        getData({filter: newFiltered, fromList: true})
                                      }
                                    }
                                  }}>{eachList?.platform}</div>
                                </div>
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["spend"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["revenue"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["roas"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["leads"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["cpl"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["clicks"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["impr"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["ctr"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["cpc"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["%_of_product"] ?? "-"
                                }
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableCard>
                </>
              )}
            </div>

            <div className="">
              <div className="pb-4">
                <TitleHeading title={'Breakdown By Device'} />
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : !lists?.breakdown_by_device?.length ? (
                <div className="w-full h-full flex items-center justify-center">
                  <DataNotFound title={"Data"} />
                </div>
              ) : (
                <>
                  <TableCard>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell header sticky><TableHeaderWrap>Device</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Spend</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Revenue</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>ROAS</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Leads</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CPL</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Clicks</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>Impressions</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CTR</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>CPC</TableHeaderWrap></TableCell>
                          <TableCell header><TableHeaderWrap>% Product</TableHeaderWrap></TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.breakdown_by_device?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`} className={deviceId == eachList?.device ? "[&>td]:!bg-blue-300" : ""}>
                              <TableCell sticky>
                                <div className="flex items-center gap-[10px]">
                                  <div className="leading-5 underline decoration-dashed font-bold decoration-gray-500 cursor-pointer hover:opacity-70" onClick={() => {
                                    if(deviceId == eachList?.device){
                                      setDeviceId("");
                                      let newFiltered = [...filterReturn?.filter((preFil) => preFil.name != "device")]
                                      setFilterReturn(newFiltered);
                                      getData({filter: newFiltered, fromList: true})
                                    }else{
                                      setDeviceId(eachList?.device);
                                      if(filterReturn?.find(eachFilter => eachFilter?.name == "device")?.value?.length){
                                        let newFiltered = [...filterReturn?.filter((preFil) => preFil.name != "device"), {
                                          name: "device",
                                          label: "Device",
                                          options: ["is"],
                                          selectedOpt: "is",
                                          value: [eachList?.device],
                                          type: "dropdown",
                                          dropdown: apiFilters?.devices?.map((eachDevice) => ({id: eachDevice, name: eachDevice})),
                                          dropdownKey: "name",
                                          dropdownVal: "id",
                                          isMulti: true,
                                          isChecked: true
                                        }]
                                        setFilterReturn(newFiltered);
                                        getData({filter: newFiltered, fromList: true})
                                      }else{
                                        let newFiltered = [...filterReturn, {
                                          name: "device",
                                          label: "Device",
                                          options: ["is"],
                                          selectedOpt: "is",
                                          value: [eachList?.device],
                                          type: "dropdown",
                                          dropdown: apiFilters?.devices?.map((eachDevice) => ({id: eachDevice, name: eachDevice})),
                                          dropdownKey: "name",
                                          dropdownVal: "id",
                                          isMulti: true,
                                          isChecked: true
                                        }]
                                        setFilterReturn(newFiltered);
                                        getData({filter: newFiltered, fromList: true})
                                      }
                                    }
                                  }}>{eachList?.device}</div>
                                </div>
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["spend"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["revenue"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["roas"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["leads"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["cpl"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["clicks"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["impr"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["ctr"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["cpc"] ?? "-"
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  eachList?.["%_of_product"] ?? "-"
                                }
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableCard>
                </>
              )}
            </div>
          </div>
        </TableCard>
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-brand-performance-analysis"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
          }}
          apiUrl="get-brand-performance-analysis"
        />
      )}
    </>
  );
};

export default PPCProductSummary;
